export default "__VITE_ASSET__BuzV6xor__"